import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Radio.scss';

const Radio = ({ id, options, selected, inputChange, hidden = false, variation = false, label = false, error = false }) => {
	const inputChangeHandler = (e) => {
		e.preventDefault();
		const value = e.target.value;
		inputChange(value);
	};

	const choices = options.map((option) => (
		<label key={option.key} htmlFor={`${id}_${option.key}`} className={[s.radio, (option.key === selected ? s.radio__selected : null), (variation ? s[`radio__${variation}`] : null), (hidden ? s.radio__hidden : null), (option.disabled ? s.radio__disabled : null)].join(' ')}>
			<input className={s.radio_input} id={`${id}_${option.key}`} type="radio" name={id} value={option.key} disabled={option.disabled} checked={option.key === selected} onChange={inputChangeHandler} />
			<span /><span className={s.radio_content}>{ option.value }</span>
			{ option.info ? <p className={s.radio_info}>{option.info}</p> : null }
		</label>
	));

	if (label) {
		return (
			<div className={[s.radioContainer, (variation ? s[`radioContainer__${variation}`] : null), (error ? s.radioContainer__error : null)].join(' ')}>
				<span className={s.radioContainer_label}>{ label }</span>
				{ choices }
			</div>
		);
	}
	return choices;
};

export default hot(module)(Radio);
